import classNames from 'classnames';
import { useContext } from 'react';
import { FormContext } from './FormContext';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
    onChangeValue: (text: string) => void;
};
export function TextField({
    className,
    onChangeValue,
    onChange,
    ...props
}: Props) {
    const { validationColors } = useContext(FormContext);
    return (
        <input
            {...props}
            type="text"
            className={classNames(
                'p-10',
                'w-full resize-none',
                'text-body text-grey',
                'border-[1px] outline-1 outline-offset-[-2px] focus:outline',
                'disabled:bg-cool-grey disabled:opacity-30',
                'read-only:pointer-events-none read-only:bg-cool-grey',
                'placeholder-cursive font-cursive placeholder-grey-textfield-placeholder placeholder:italic',
                {
                    'pr-30': validationColors != null,
                    'border-grey-textfield outline-dark-red focus:border-dark-red':
                        validationColors == null,
                },
                [validationColors?.borderColor, validationColors?.outlineColor],
                className,
            )}
            onChange={(e) => {
                onChange?.(e);
                onChangeValue(e.currentTarget.value);
            }}
        />
    );
}
